import { render, staticRenderFns } from "./Pieces.vue?vue&type=template&id=4c959ccc&scoped=true&"
import script from "./Pieces.vue?vue&type=script&lang=ts&"
export * from "./Pieces.vue?vue&type=script&lang=ts&"
import style0 from "./Pieces.vue?vue&type=style&index=0&id=4c959ccc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c959ccc",
  null
  
)

export default component.exports